import { Component, Inject, OnInit } from '@angular/core';
import { MAT_CHECKBOX_CLICK_ACTION, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

import { IDataset } from '../../models/dataset';

/** A model for a dataset that can be selected/deselected with a human readable label */
interface IClickableDataset {
    checked: boolean;
    dataset: IDataset;
    name: string;
}

/**
 * Angular component for a popup that displays all csv downloadable datasets in a plot.
 * Allows selection of datasets for download from LATIS
 */
@Component({
    selector: 'sci-download-dialog',
    templateUrl: './download-dialog.component.html',
    styleUrls: [ '../../assets/dialog-style.css' ],
    providers: [
        { provide: MAT_CHECKBOX_CLICK_ACTION, useValue: 'noop' } // requires us to manually update checkbox models
    ]
})
export class DownloadDialogComponent implements OnInit {
    datasets: IDataset[];
    allSelected = true;
    someSelected = true;
    checkedList: IClickableDataset[];

    constructor( public dialogRef: MatDialogRef<DownloadDialogComponent>, @Inject(MAT_DIALOG_DATA) public data ) {}

    /** on init, create a list of clickable objects from the dataset list provided */
    ngOnInit() {
        this.datasets = this.data.datasets;
        this.checkedList = this.datasets.map( dataset => {
            return {
                checked: true,
                name: dataset.name,
                dataset: dataset
            };
        });
    }

    /**
     * If all datasets are selected, deselects all datasets
     * If not all datasets are selected, selects all datasets
     */
    toggleSelectAll() {
        if ( this.allSelected ) {
            this.allSelected = false;
            this.checkedList = this.checkedList.map( item => {
                return { checked: false, name: item.name, dataset: item.dataset };
            });
        } else {
            this.allSelected = true;
            this.checkedList = this.checkedList.map( item => {
                return { checked: true, name: item.name, dataset: item.dataset };
            });
        }
        this.calculateSelectedState();
    }

    /** Toggles the checkbox for a clickable dataset */
    toggleSelect( item: IClickableDataset ) {
        item.checked = !item.checked;
        this.calculateSelectedState();
    }

    /** calculate the state of the all datasets checkbox */
    calculateSelectedState() {
        this.someSelected = this.checkedList.some( item => item.checked );
        this.allSelected = this.checkedList.every( item => item.checked );
    }

    /** closes the dialog and provides a list of datasets to the return function for downloading */
    downloadSelectedDatasets() {
        const selectedDatasets = this.checkedList.filter( item => item.checked ).map( item => item.dataset );
        this.dialogRef.close( selectedDatasets );
    }
}
